<template>
    <div class="auth-box-w">
      <div class="logo-w" style="padding: 10% 20%;">
        <div class="animated-logo">
          <a href="index.html">
            <LogoComponent
              :css="'width: 100%;'"
            ></LogoComponent>
          </a>
        </div>
      </div>
      <!-- Animación de texto escrito -->
      <!--<h4 class="auth-header typing-text"></h4>-->
      <h4 class="auth-header">Inicio de Sesión</h4>
      <form method="post" @submit="login">
        <div id="div_id_username" class="form-group">
          <i class="fas fa-user-circle"></i>
          &nbsp;
          <label for="id_username" class="col-form-label requiredField">
            Usuario
            <span class="asteriskField" style="color: red;">*</span>
          </label>
          <div>
            <input v-model="username" type="text" name="username" autofocus="autofocus" required="required"
              id="id_username" class="textinput textInput form-control">
            <small class="form-text text-danger">{{ errors.username[0] }}</small>
          </div>
        </div>
        <div id="div_id_password" class="form-group">
          <i class="fas fa-key"></i>
          &nbsp;
          <label for="id_password" class="col-form-label requiredField">
            Contraseña
            <span class="asteriskField" style="color: red;">*</span>
          </label>
          <div>
            <input type="password" v-model="password" name="password" required="required" id="id_password"
              class="textinput textInput form-control">
            <small class="form-text text-danger">{{ errors.password[0] }}</small>
          </div>
          <br>
          <div class="left-button">
            <div style="color: grey;">
              <input type="checkbox" @click="showPass()" id="scales" name="scales" />
              <label for="scales"> &nbsp;&nbsp;&nbsp;Mostrar Contraseña&nbsp;<i class="fas fa-eye"></i></label>
            </div>
            <!--<input type="checkbox">&nbsp;Recuérdame-->
          </div>
          <br>
          <div class="center-button">
            <br>
            <button type="submit" class="btn btn-primary btn-block">Iniciar Sesión</button>
            <div class="form-check-inline">
            </div>
          </div>
          <div style="text-align: center;">
            <a href="#">¿Olvidaste tu contraseña?</a>
          </div>
        </div>
        <div class="buttons-w">
          <button class="btn btn-blue btn-block" @click="nuevo_usuario()" disabled>Registrarse</button>
        </div>
      </form>
    </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import LogoComponent from "@/components/LogoComponent.vue";

export default {
  data() {
    return {
      username: "",
      password: "",
      errors: {
        username: [],
        password: [],
        non_field_errors: []
      }
    };
  },
  components: {
    LogoComponent
  },
  beforeMount() {
    this.$store.commit("SET_LAYOUT", "clean-layout");
  },
  mounted() {
    // this.typingEffect();
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let self = this;
      this.$data.errors = {
        username: [],
        password: [],
        non_field_errors: []
      };

      await AuthService.login({
        username: this.$data.username,
        password: this.$data.password
      })
        .then(res => {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("username", res.data.username);
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("email", res.data.email);
          localStorage.setItem("image", res.data.image);
          localStorage.setItem("vistas_permitidas", JSON.stringify(res.data.vistas_permitidas));
          localStorage.setItem("secciones_permitidas", JSON.stringify(res.data.secciones_permitidas));
          localStorage.setItem("id_usuario", res.data.id);
          localStorage.setItem("is_superuser", res.data.is_superuser);
          localStorage.setItem("tipo_usuario", res.data.tipo_usuario);
          localStorage.setItem("permisos", JSON.stringify(res.data.permisos));
          localStorage.setItem("grupos", JSON.stringify(res.data.grupos));
          localStorage.setItem("tiendas_usuario", JSON.stringify(res.data.tiendas_usuario));
          const hhusers = [
            "PICKEADOR",
            "REVISOR_ESTACION",
            "BODEGUERO",
            "PASILLO",
            "USUARIO_CEDIS",
          ];
          if (hhusers.includes(res.data.tipo_usuario)) {
            self.$store.commit("SET_LAYOUT", "hh-layout");
          } else {
            self.$store.commit("SET_LAYOUT", "app-layout");
          }
          self.$store.commit("SET_MODULE", "dashboard");
          let nexturl = localStorage.getItem("nexturl");
          if (!nexturl) {
            nexturl = '/';
          }
          window.location.href = nexturl;
          // this.$router.push({ name: "dashboard" });
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.errors.username = [];
            this.errors.password = [];
            this.errors.non_field_errors = err.response.data.non_field_errors || [];
            this.$toast.warning(" Revise sus Credenciales", " No se pudo Iniciar Sesión ", {
              position: 'topRight'
            });
          }
        });
    },
    showPass() {
      var x = document.getElementById("id_password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    /*   typingEffect() {
       const text = "Inicio de Sesión";
       const span = document.querySelector(".typing-text");
       let index = 0;
 
       function type() {
         if (index < text.length) {
           span.textContent += text[index];
           index++;
           setTimeout(type, 100); // Controla la velocidad de escritura
         }
       }
 
       type();
     }, */
  }
};
</script>
<style>
.fade-in-image {
  animation: fadeIn 4s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.center-button {
  text-align: center;
}

.button {
  position: absolute;
  top: 50%;
}

.animated-logo {
  display: inline-block;
  animation: logoAnimation 0.8s ease-in-out;
}

@keyframes logoAnimation {
  0% {
    transform: scale(0.8) rotate(0deg);
  }

  50% {
    transform: scale(1.1) rotate(5deg);
  }

  100% {
    transform: scale(1) rotate(0deg);
  }
}

.logo {
  width: 100%;
  height: auto;
}

/* .typing-text {
  overflow: hidden;
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.01em;
  animation: typing 2s steps(40, end), blink-caret 0.50s step-end
}

@keyframes typing {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

@keyframes blink-caret {

  from,
  to {
    border-color: transparent;
  }

  50% {
    border-color: transparent;
  }
} */
</style>
